import {
    ROUTES_ACTIVATE_ACCOUNT,
    ROUTES_ACTIVATE_ACCOUNT_CLUB,
    ROUTES_ACTIVATE_ACCOUNT_FINAL,
    ROUTES_INVITATION_FOR_MEMBERSHIP_ACCEPT,
    ROUTES_LOGIN
} from '@/constants/routes';
import { LUDUM_ERROR_CODES, LUDUM_USER_STATUSES } from '@/constants';
const { BAD_REQUEST } = LUDUM_ERROR_CODES;
const { INVITED } = LUDUM_USER_STATUSES;
import { get } from 'axios';
import getObjectPath from 'get-object-path';

export default {
    name: 'activate-account-main',
    path: '/activate-account',
    component: () => import(/*webpackChunkName: 'auth-activate-account'*/ '@/views/auth/AuthActivateAccount'),
    children: [
        {
            path: ':code',
            name: ROUTES_ACTIVATE_ACCOUNT,
            meta: {
                requiresAuth: false
            },
            beforeEnter: guardActivateAccount,
            component: () =>
                import(
                    /*webpackChunkName: 'auth-activate-account'*/ '@/components/auth/activate-account/ActivateAccountStepUserForm'
                )
        },
        {
            path: ':code/club',
            name: ROUTES_ACTIVATE_ACCOUNT_CLUB,
            meta: {
                requiresAuth: true
            },
            beforeEnter: guardActivateAccountClub,
            component: () =>
                import(
                    /*webpackChunkName: 'auth-activate-account'*/ '@/components/auth/activate-account/ActivateAccountStepClub'
                )
        },
        {
            path: ':code/final',
            name: ROUTES_ACTIVATE_ACCOUNT_FINAL,
            meta: {
                requiresAuth: true
            },
            beforeEnter: guardActivateAccountFinal,
            component: () =>
                import(
                    /*webpackChunkName: 'auth-activate-account'*/ '@/components/auth/activate-account/ActivateAccountStepFinal'
                )
        }
    ]
};

async function guardActivateAccount(to, from, next) {
    try {
        const {
            data: { data, status_code }
        } = await get(`${api}get-user-data/${to.params.code}`, {
            activation_code: to.params.code,
            client_id: process.env.VUE_APP_LUDUM_CLIENT_ID,
            client_secret: process.env.VUE_APP_LUDUM_CLIENT_SECRET
        });

        if (status_code === BAD_REQUEST) {
            next({ name: ROUTES_LOGIN });
        } else {
            to.params.user = data;

            const isInvited = getObjectPath(data, 'current_club_user.data.status.id') === INVITED;

            if (data.email_verified && isInvited) {
                next({
                    name: ROUTES_INVITATION_FOR_MEMBERSHIP_ACCEPT,
                    query: {
                        activation_code: to.params.code,
                        club_id: getObjectPath(data, 'current_club_user.data.club_id')
                    }
                });
            } else if (data.email_verified && !isInvited) {
                const clubCreatorId = getObjectPath(data, 'current_club_user.data.club.data.creator_id');
                const isClubCreator = data.id === clubCreatorId;
                next({
                    name: isClubCreator ? ROUTES_ACTIVATE_ACCOUNT_CLUB : ROUTES_ACTIVATE_ACCOUNT_FINAL,
                    params: { code: to.params.code }
                });
            } else {
                next();
            }
        }
    } catch (error) {
        next({ name: ROUTES_LOGIN });
    }
}

async function guardActivateAccountClub(to, from, next) {
    try {
        const {
            data: { data, status_code }
        } = await get(`${api}get-user-data/${to.params.code}`, {
            activation_code: to.params.code,
            client_id: process.env.VUE_APP_LUDUM_CLIENT_ID,
            client_secret: process.env.VUE_APP_LUDUM_CLIENT_SECRET
        });

        if (status_code === BAD_REQUEST) {
            next({ name: ROUTES_LOGIN });
        } else {
            to.params.user = data;

            const clubCreatorId = getObjectPath(data, 'current_club_user.data.club.data.creator_id');
            const isClubCreator = data.id === clubCreatorId;

            if (!isClubCreator) {
                next({
                    name: ROUTES_ACTIVATE_ACCOUNT_FINAL,
                    params: { code: to.params.code }
                });
            } else {
                next();
            }
        }
    } catch (error) {
        next({ name: ROUTES_LOGIN });
    }
}

async function guardActivateAccountFinal(to, from, next) {
    try {
        const {
            data: { data, status_code }
        } = await get(`${api}get-user-data/${to.params.code}`, {
            activation_code: to.params.code,
            client_id: process.env.VUE_APP_LUDUM_CLIENT_ID,
            client_secret: process.env.VUE_APP_LUDUM_CLIENT_SECRET
        });

        if (status_code === BAD_REQUEST) {
            next({ name: ROUTES_LOGIN });
        } else {
            to.params.user = data;
            next();
        }
    } catch (error) {
        next({ name: ROUTES_LOGIN });
    }
}
